"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = exports.FormError = exports.FormField = exports.Label = exports.Textarea = exports.Input = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 * RedPanda UI - Input Component
 * 統一的輸入元件，支援多種變體和深淺模式
 */
const react_1 = __importDefault(require("react"));
const utils_1 = require("../../utils");
const class_variance_authority_1 = require("class-variance-authority");
const inputVariants = (0, class_variance_authority_1.cva)('h-10 w-full px-3 py-2 border border-gray-300 dark:border-slate-600 rounded-md shadow-sm focus:outline-none focus-visible:ring-brand-500 focus-visible:border-brand-500 placeholder:text-gray-500 dark:placeholder:text-gray-300 dark:bg-slate-700 dark:text-white disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500 dark:disabled:bg-slate-600 dark:disabled:text-gray-400', {
    variants: {
        variant: {
            default: 'bg-white',
            error: 'border-red-500 focus-visible:ring-red-500 focus-visible:border-red-500 dark:border-red-600'
        }
    },
    defaultVariants: {
        variant: 'default'
    }
});
exports.Input = react_1.default.forwardRef(({ className, variant, type, ...props }, ref) => ((0, jsx_runtime_1.jsx)("input", { type: type, ref: ref, className: (0, utils_1.cn)(inputVariants({ variant }), className), ...props })));
exports.Input.displayName = 'Input';
// Textarea Component
const textareaVariants = (0, class_variance_authority_1.cva)('block min-h-[80px] w-full rounded-md border px-3 py-2 text-sm shadow-sm focus:outline-none placeholder:text-gray-500 disabled:cursor-not-allowed disabled:opacity-50 dark:placeholder:text-gray-300', {
    variants: {
        variant: {
            default: 'border-gray-300 bg-white focus-visible:ring-brand-500 focus-visible:border-brand-500 dark:border-slate-600 dark:bg-slate-700 dark:text-white',
            error: 'border-red-500 bg-white focus-visible:ring-red-500 focus-visible:border-red-500 dark:border-red-600 dark:bg-slate-700 dark:text-white'
        }
    },
    defaultVariants: {
        variant: 'default'
    }
});
exports.Textarea = react_1.default.forwardRef(({ className, variant, ...props }, ref) => ((0, jsx_runtime_1.jsx)("textarea", { ref: ref, className: (0, utils_1.cn)(textareaVariants({ variant }), className), ...props })));
exports.Textarea.displayName = 'Textarea';
exports.Label = react_1.default.forwardRef(({ className, ...props }, ref) => ((0, jsx_runtime_1.jsx)("label", { ref: ref, className: (0, utils_1.cn)('block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2', className), ...props })));
exports.Label.displayName = 'Label';
exports.FormField = react_1.default.forwardRef(({ className, ...props }, ref) => ((0, jsx_runtime_1.jsx)("div", { ref: ref, className: (0, utils_1.cn)('mb-4', className), ...props })));
exports.FormField.displayName = 'FormField';
exports.FormError = react_1.default.forwardRef(({ className, ...props }, ref) => ((0, jsx_runtime_1.jsx)("p", { ref: ref, className: (0, utils_1.cn)('text-sm text-red-600 dark:text-red-500', className), ...props })));
exports.FormError.displayName = 'FormError';
// Select Component
const selectVariants = (0, class_variance_authority_1.cva)('block w-full border border-solid rounded-md shadow-sm py-2 px-3 text-sm focus:outline-none disabled:cursor-not-allowed disabled:opacity-50 bg-white dark:bg-slate-700 appearance-none redpanda-select', {
    variants: {
        variant: {
            default: 'border-gray-300 focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:border-brand-500 dark:border-slate-600 dark:text-white',
            error: 'border-red-500 focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:border-red-500 dark:border-red-600 dark:text-white'
        }
    },
    defaultVariants: {
        variant: 'default'
    }
});
exports.Select = react_1.default.forwardRef(({ className, variant, children, ...props }, ref) => ((0, jsx_runtime_1.jsx)("select", { ref: ref, className: (0, utils_1.cn)(selectVariants({ variant }), className), ...props, children: children })));
exports.Select.displayName = 'Select';
